export const CONFIGURATIONS = {
  production: {
    name: 'production',
    label: 'Production',
    authorizeUrl: 'https://api.tradier.com/v1/oauth/authorize',
    clientId: 'y93498ym5a4fURrKoGISbGGqs6kQJntf',
    scopes: 'read,write,market,trade,stream',
    apiUrl: 'https://api.tradier.com',
    backendUrl: 'https://p-be-dash.tradier.com',
    backendAuthUrl: 'https://p-be-auth.tradier.com',
    backendOnboardingUrl: 'https://p-be-onboarding.tradier.com',
    oidClientId: 'web',
    oidCallbackUrl: 'https://web.tradier.com/callback',
    authUrl: 'https://auth.tradier.com',
    onboardingUrl: 'https://onboarding.tradier.com',
    wsUrl: 'wss://ws.tradier.com',
    intervals: {
      documents: 4 * 60 * 1000, // 4 minutes
      dashboard: 5000, // 5 seconds
      trade: 5000, // 5 seconds
      quotes: 5000, // 5 seconds
      status: 30000, // 30 seconds
      balances: 5000, // 5 seconds
      watchlists: 5000, // 5 seconds
      positions: 5000, // 5 seconds
      orders: 5000, // 5 seconds
      operationalAlerts: 30000, // 30 seconds
    },
    mixpanelToken: 'e1499b4e0bdaeeb054a0af11d846d353',
    ga4MeasurementId: 'G-3PK48K3W99',
    facebookPixelId: '301045650573393',
    plaid: {
      publicToken: 'c8f14fd941afa12b921b721f51c590',
      env: 'production',
    },
    sendSafely: {
      dropzoneId: 'tI9lh-UYvbF69It7khUm1lX1AjSQDH02eQ3QMb_xFJc',
      dropzoneUrl: 'https://tradierbrokerage.sendsafely.com',
    },
    cookieNames: {
      JWT_COOKIE_NAME: 'tradier_web_token',
      REDIRECT_COOKIE_NAME: 'tradier_web_redirect',
      STATE_COOKIE_NAME: 'tradier_web_state',
      ONBOARDING_PARAMS_COOKIE_NAME: 'tradier_onboarding_params',
      ACCOUNT_COOKIE_NAME: 'tradier_web_account',
      ENVIRONMENT_COOKIE_NAME: 'tradier_web_environment',
      ACCESS_TOKEN_COOKIE_NAME: 'tradier_web_access_token',
    },
    cookieOptions: {
      path: '/',
      domain: 'web.tradier.com',
      sameSite: true,
      secure: true,
    },
    smartyAuthId: '10529299773417721',
  },
  staging: {
    name: 'staging',
    label: 'Staging',
    authorizeUrl: 'https://staging.api.tradier.com/v1/oauth/authorize',
    clientId: 'YpQnFoqPUnqtTeR3glFp9G2pfG4PnMX2',
    scopes: 'read,write,market,trade,stream',
    apiUrl: 'https://staging.api.tradier.com',
    backendUrl: 'https://s-be-dash.tradier.com',
    backendAuthUrl: 'https://s-be-auth.tradier.com',
    backendOnboardingUrl: 'https://s-be-onboarding.tradier.com',
    oidClientId: 'web', // web-local for development
    oidCallbackUrl: 'https://staging-web.tradier.com/callback', // http://localhost:5173/callback for development
    authUrl: 'https://staging-auth.tradier.com', // http://localhost:8080 for development
    onboardingUrl: 'https://staging-onboarding.tradier.com', // http://localhost:4200 for development
    wsUrl: 'wss://staging-ws.tradier.com',
    intervals: {
      documents: 4 * 60 * 1000, // 4 minutes
      dashboard: 5000, // 5 seconds
      trade: 5000, // 5 seconds
      quotes: 5000, // 5 seconds
      status: 30000, // 30 seconds
      balances: 5000, // 5 seconds
      watchlists: 5000, // 5 seconds
      positions: 5000, // 5 seconds
      orders: 5000, // 5 seconds
      operationalAlerts: 30000, // 30 seconds
    },
    mixpanelToken: '22eca46fc5a3836ae431996906e957a6',
    ga4MeasurementId: 'G-3PK48K3W99',
    facebookPixelId: '301045650573393',
    plaid: {
      publicToken: 'c8f14fd941afa12b921b721f51c590',
      env: 'sandbox',
    },
    sendSafely: {
      dropzoneId: 'tI9lh-UYvbF69It7khUm1lX1AjSQDH02eQ3QMb_xFJc',
      dropzoneUrl: 'https://tradierbrokerage.sendsafely.com',
    },
    cookieNames: {
      JWT_COOKIE_NAME: 'tradier_web_token',
      REDIRECT_COOKIE_NAME: 'tradier_web_redirect',
      STATE_COOKIE_NAME: 'tradier_web_state',
      ONBOARDING_PARAMS_COOKIE_NAME: 'tradier_onboarding_params',
      ACCOUNT_COOKIE_NAME: 'tradier_web_account',
      ENVIRONMENT_COOKIE_NAME: 'tradier_web_environment',
      ACCESS_TOKEN_COOKIE_NAME: 'tradier_web_access_token',
    },
    cookieOptions: {
      path: '/',
      domain: 'staging-web.tradier.com',
      sameSite: true,
      secure: true,
    },
    smartyAuthId: '10529299773417721',
  },
  sandbox: {
    name: 'sandbox',
    label: 'Sandbox',
    authorizeUrl: null,
    clientId: null,
    scopes: null,
    apiUrl: 'https://sandbox.tradier.com',
    backendUrl: 'https://sb-be-dash.tradier.com',
    backendOnboardingUrl: 'https://s-be-onboarding.tradier.com',
    authUrl: 'https://staging-auth.tradier.com', // http://localhost:8080 for development
    onboardingUrl: 'https://staging-onboarding.tradier.com', // http://localhost:4200 for development
    wsUrl: 'wss://sandbox-ws.tradier.com',
    intervals: {
      documents: 4 * 60 * 1000, // 4 minutes
      dashboard: 5000, // 5 seconds
      trade: 5000, // 5 seconds
      quotes: 5000, // 5 seconds
      status: 30000, // 30 seconds
      balances: 5000, // 5 seconds
      watchlists: 5000, // 5 seconds
      positions: 5000, // 5 seconds
      orders: 5000, // 5 seconds
      operationalAlerts: 30000, // 30 seconds
    },
    mixpanelToken: '22eca46fc5a3836ae431996906e957a6',
    ga4MeasurementId: 'G-3PK48K3W99',
    facebookPixelId: '301045650573393',
    plaid: {
      publicToken: 'c8f14fd941afa12b921b721f51c590',
      env: 'sandbox',
    },
    sendSafely: {
      dropzoneId: 'tI9lh-UYvbF69It7khUm1lX1AjSQDH02eQ3QMb_xFJc',
      dropzoneUrl: 'https://tradierbrokerage.sendsafely.com',
    },
  },
  development: {
    name: 'development',
    label: 'Development',
    authorizeUrl: 'https://staging.api.tradier.com/v1/oauth/authorize',
    clientId: 'YpQnFoqPUnqtTeR3glFp9G2pfG4PnMX2',
    scopes: 'read,write,market,trade,stream',
    apiUrl: 'https://staging.api.tradier.com',
    backendUrl: 'https://s-be-dash.tradier.com',
    backendAuthUrl: 'https://s-be-auth.tradier.com',
    backendOnboardingUrl: 'https://s-be-onboarding.tradier.com',
    oidClientId: 'web-local',
    oidCallbackUrl: 'http://localhost:5173/callback',
    authUrl: 'https://staging-auth.tradier.com',
    onboardingUrl: 'https://staging-onboarding.tradier.com',
    wsUrl: 'wss://staging-ws.tradier.com',
    intervals: {
      documents: 4 * 60 * 1000, // 4 minutes
      dashboard: 5000, // 5 seconds
      trade: 5000, // 5 seconds
      quotes: 5000, // 5 seconds
      status: 30000, // 30 seconds
      balances: 5000, // 5 seconds
      watchlists: 5000, // 5 seconds
      positions: 5000, // 5 seconds
      orders: 5000, // 5 seconds
      operationalAlerts: 30000, // 30 seconds
    },
    mixpanelToken: '22eca46fc5a3836ae431996906e957a6',
    ga4MeasurementId: 'G-3PK48K3W99',
    facebookPixelId: '301045650573393',
    plaid: {
      publicToken: 'c8f14fd941afa12b921b721f51c590',
      env: 'sandbox',
    },
    sendSafely: {
      dropzoneId: 'tI9lh-UYvbF69It7khUm1lX1AjSQDH02eQ3QMb_xFJc',
      dropzoneUrl: 'https://tradierbrokerage.sendsafely.com',
    },
    cookieNames: {
      JWT_COOKIE_NAME: 'tradier_web_token',
      REDIRECT_COOKIE_NAME: 'tradier_web_redirect',
      STATE_COOKIE_NAME: 'tradier_web_state',
      ONBOARDING_PARAMS_COOKIE_NAME: 'tradier_onboarding_params',
      ACCOUNT_COOKIE_NAME: 'tradier_web_account',
      ENVIRONMENT_COOKIE_NAME: 'tradier_web_environment',
      ACCESS_TOKEN_COOKIE_NAME: 'tradier_web_access_token',
    },
    cookieOptions: {
      path: '/',
      domain: 'localhost',
      sameSite: true,
      secure: true,
    },
    smartyAuthId: '10529299773417721',
  },
};
